<script>
import help from '@/components/help.vue'
import pages from '@/components/pages.vue'
import numberPrecision from 'number-precision';
import Clipboard from 'clipboard';

export default { 
  data(){
    return{
      loading: true,
      isToastShow: false,
      toastText: this.$t('TxView.Copied'),
      tx_id: '',
      transaction: {},
      is_para: false,
      senderAddress: [],
      receiveAddress: [],
      blockchain: {
        '1': 'Paralsim',
        '2': 'Ethereum',
        '3': 'Hyperchain'
      },
      paraTime: 0,
    }
  },
  components:{
    help,pages
  },
  created(){
    this.init();
    const clipboard = new Clipboard('.copy-btn');
    clipboard.on('success', () => {
      // 复制成功的回调函数
      console.log('复制成功');
      this.toastText = this.$t('TxView.Copied');
      this.handleCopied();
    });
    clipboard.on('error', () => {
      // 复制失败的回调函数
      console.log('复制失败');
    });    
  },
  watch: {
    $route(){
      this.init();
    }
  },
  methods:{
    init(){
      this.senderAddress.length = 0;
      this.receiveAddress.length = 0;
      this.$http({
        url:`query/transaction/info/?tx_id=${ this.$route.params.TxID }`,
        baseURL: process.env.VUE_APP_BLOCKCHAIN,
        method: 'get',
      }).then((res)=>{
        var data = res.data;

        if(data.status == 200){              
          this.tx_id = this.$route.params.TxID;
          this.transaction = data.data;

          if (data.data.details) {
            this.is_para = true;
            this.transaction.details.forEach(itemDetails => {
              if (itemDetails.vin) {
                itemDetails.vin.forEach(item => {
                  if (item.coinbase) {
                    this.senderAddress.push('0');
                  } else if (item.scriptSig && item.scriptSig.address) {
                    if (this.senderAddress.indexOf(item.scriptSig.address) == -1) {
                      this.senderAddress.push(item.scriptSig.address);
                    }                    
                  }
                });
              }
              if (itemDetails.vout) {
                itemDetails.vout.forEach(itemOut => {
                  if (itemOut.addresses) {
                    itemOut.addresses.forEach(item => {
                      if (this.receiveAddress.indexOf(item) == -1) {
                        this.receiveAddress.push(item);
                      }
                    });
                  }
                });
              }

            });


            if (this.receiveAddress.length == 0) {
              this.receiveAddress.push('0');
            }

            // if (this.senderAddress.length == 0) {
            //   this.senderAddress.push('0');
            // }

          }
        } else {
          this.toastText = data.message;
          this.handleCopied();
        }
      });
      window.scrollTo(0,0);      
      this.loading = false;
    },
    addressThumbnail(address){
      console.log(address)
      if(!address) return;
      if(address.length < 12) return address;
      let first = address.substring(0,6);
      let last = address.substring(address.length-4);
      return `${ first }...${ last }`;
    },
    handleCopied() {
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 1000);      
    },
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    /**
     * 格式化函数 ， 给日期格式化
     * date为 new Date()对象， fmt为 'yyyy-MM-dd hh:mm:ss'的格式
     */
    formatDate(date, fmt) {
      //获取年份
      if (/(Y+)/.test(fmt)) {
        // 把数字变成字符串
        let dateY = date.getFullYear() + "";
        //RegExp.$1 在判断中出现过，且是括号括起来的，所以 RegExp.$1 就是 "yyyy"
        fmt = fmt.replace(RegExp.$1, dateY.substr(4 - RegExp.$1.length));
      }

      //获取其他
      let o = {
        "M+": date.getMonth() + 1,
        "D+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },

  }
}
</script>

<template>
  <div class="block-information clearfix" v-loading="loading">
    <div class="fr">
      <img src="@/../public/static/img/blockView/java.png">
    </div>
    <div class="fl">
  <div class="tit">{{ $t('TxView.TxDetail') }}</div>
  <div class="TxView" v-if="is_para">
    <div class="Chain">       
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.TXID') }}:</div>
          <div class="FontSize2-14 Value TextColor4" style="color: #EB7326">
            {{ tx_id }}
            <img @click.prevent class="copy-btn ml-4 copy" :data-clipboard-text="tx_id" size="0.16rem" :src="require('@/assets/images/copy.svg')" />
          </div>
        </div>
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.TXData') }}:</div>
          <div class="van-row data">
            <pre>{{ transaction.details }}</pre>
          </div>
        </div>           
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.Sender') }}:</div>
            <div class="FontSize2-14 Value TextColor4" style="flex-direction: column;">
                <div v-for="(item, keyIndex) in senderAddress" :key="keyIndex">
                    <div class="FontSize2-14" style="color: #EB7326"><span @click="$router.push(`/TxList/${item}`)">{{ item }}</span>
                      <img @click.prevent :data-clipboard-text="item" class="copy-btn ml-4 copy" size="0.16rem" :src="require('@/assets/images/copy.svg')" />
                    </div>
                </div>                         
          </div>
        </div>         
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.Receiver') }}:</div>
            <div class="FontSize2-14 Value TextColor4" style="flex-direction: column;">
                <div v-for="(item, keyIndex) in receiveAddress" :key="keyIndex">
                    <div class="FontSize2-14" style="color: #EB7326">
                      <span @click="$router.push(`/TxList/${item}`)">{{ item }}</span>
                      
                      <img @click.prevent :data-clipboard-text="item" class="copy-btn ml-4 copy" size="0.16rem" :src="require('@/assets/images/copy.svg')" />
                    </div>
                </div>                         
          </div>
        </div>                 
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.Time') }}:</div>
          <div class="FontSize2-14 Value TextColor4">{{ transaction.tx_time > 0 ? formatDate(new Date(transaction.tx_time * 1000), "YYYY-MM-DD hh:mm") : '' }}</div>
        </div>      
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.Mature') }}:</div>
          <div class="FontSize2-14 Value TextColor4">{{ transaction.mature }}</div>
        </div>           
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.State') }}:</div>      
          <div class="FontSize2-14 Value TextColor4" v-if="transaction.status == 'Pending'" style="color: #007BD3">{{ $t('TxView.Pending') }}</div>
          <div class="FontSize2-14 Value TextColor4" v-else-if="transaction.status == 'Confirmed'" style="color: #2B9719">{{ $t('TxView.Confirmed') }}</div>
          <div class="FontSize2-14 Value TextColor4" v-else-if="transaction.status == 'Fail'">{{ $t('TxView.Failed') }}</div>
        </div>        
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.BlockNo') }}:</div>
          <div class="FontSize2-14 Value TextColor4"><span v-if="transaction.hyperchain && transaction.hyperchain.hid && transaction.hyperchain.hid > 0">
            <a  style="color: #EB7326" :href="`/static/hyperchainExplorer.html#/LocalBlockView/${transaction.hyperchain.hid}/${transaction.hyperchain.chain_num}/${transaction.hyperchain.block_id}`">{{transaction.hyperchain.hid}},{{transaction.hyperchain.chain_num}},{{transaction.hyperchain.block_id}}</a>
            <img @click.prevent class="copy-btn ml-4 copy" :data-clipboard-text="`${transaction.hyperchain.hid},${transaction.hyperchain.chain_num},${transaction.hyperchain.block_id}`" size="0.16rem" :src="require('@/assets/images/copy.svg')" />
          </span></div>
        </div>
      </div>      
  </div>
  <div class="TxView" v-if="!is_para">
    <div class="Chain">       
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.TXID') }}:</div>
          <div class="FontSize2-14 Value TextColor4" style="color: #EB7326">
            {{ tx_id }}
            <img @click.prevent :data-clipboard-text="tx_id" class="copy-btn ml-4 copy" size="0.16rem" :src="require('@/assets/images/copy.svg')" />
          </div>
        </div>
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.TXData') }}:</div>
          <div class="van-row data" style="flex-direction: column;">
            <div style="word-break: break-all;word-wrap: break-word;" v-for="(item, key) in transaction.transaction.data" :key="key">
              <span class="TextColor2 FontSize2-14 Key">
                {{ key }}
              </span>
                {{ item }}
                <img @click.prevent v-if="key=='sender' || key=='deployer' || key=='trader'" :data-clipboard-text="item" class="copy-btn ml-4 copy" size="0.16rem" :src="require('@/assets/images/copy.svg')" />
                <span v-if="key=='blockchain'">({{ blockchain[item] }})</span>
            </div>
          </div>
        </div>           
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.Sign') }}:</div>
          <div class="FontSize2-14 Value TextColor4" style="color: #EB7326">
            {{ transaction.transaction.sign }}
            <img @click.prevent :data-clipboard-text="transaction.transaction.sign" class="copy-btn ml-4 copy" size="0.16rem" :src="require('@/assets/images/copy.svg')" />
          </div>
        </div>         
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.Sender') }}:</div>
          <div class="FontSize2-14 Value TextColor4" style="color: #EB7326">
            <span @click="$router.push(`/TxList/${transaction.blockchain.msg_sender.address }`)"> {{ transaction.blockchain.msg_sender.address }} </span>
            <img @click.prevent :data-clipboard-text="transaction.blockchain.msg_sender.address" class="copy-btn ml-4 copy" size="0.16rem" :src="require('@/assets/images/copy.svg')" /></div>
        </div>   
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.Time') }}:</div>
          <div class="FontSize2-14 Value TextColor4">{{ transaction.tx_time > 0 ? formatDate(new Date(transaction.tx_time * 1000), "YYYY-MM-DD hh:mm") : '' }}</div>
        </div>
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.Mature') }}:</div>
          <div class="FontSize2-14 Value TextColor4">{{ transaction.mature }}</div>
        </div>                   
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.State') }}:</div>      
          <div class="FontSize2-14 Value TextColor4" v-if="transaction.chain_state == 0" style="color: #007BD3">{{ $t('TxView.Pending') }}</div>
          <div class="FontSize2-14 Value TextColor4" v-else-if="transaction.chain_state == 1" style="color: #2B9719">{{ $t('TxView.Confirmed') }}</div>
          <div class="FontSize2-14 Value TextColor4" v-else-if="transaction.chain_state == 2">{{ $t('TxView.Failed') }}</div>
        </div>        
        <div class="van-row Text">
          <div class="TextColor2 FontSize2-14 Key">{{ $t('TxView.BlockNo') }}:</div>
          <div class="FontSize2-14 Value TextColor4"><span v-if="transaction.hyperchain && transaction.hyperchain.hid && transaction.hyperchain.hid > 0">
            <a  style="color: #EB7326" :href="`/static/hyperchainExplorer.html#/LocalBlockView/${transaction.hyperchain.hid}/${transaction.hyperchain.chain_num}/${transaction.hyperchain.block_id}`">{{transaction.hyperchain.hid}},{{transaction.hyperchain.chain_num}},{{transaction.hyperchain.block_id}}</a>
            <img @click.prevent class="copy-btn ml-4 copy" :data-clipboard-text="`${transaction.hyperchain.hid},${transaction.hyperchain.chain_num},${transaction.hyperchain.block_id}`" size="0.16rem" :src="require('@/assets/images/copy.svg')" />
          </span></div>
        </div>
      </div>      
  </div>  
  


  <div class="context" v-show="isToastShow">
    <span class="tip">{{ toastText }}</span>
  </div> 
  </div> 
  </div>     
</template>
<style scoped lang="scss">
.copy{
  position: relative;
  z-index: 9;
}
  .section2{
    &>div{
      width: 100%;
    }
  }
  @media screen and (max-width: 500px){
    .section2{
      .table{
        width: 510px!important;
      }
    }
  }

  $Color23252A: #23252A;
.TxView{

  font-size: 14px;
  min-height: 100%;

  pre {
    white-space: pre-wrap; /* css-3 */
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: break-all;
  }

  .w200{
    width: 200px;
  }
  .Info{
    width: 100%;
    padding: 22px;
    background: #F6F9FD;
    line-height: 20px;
    
  }
  .Text{
    margin-bottom: 14px;

    &:last-child{
      margin-bottom: 0px;
    }
  }
  .Key{
    width: 90px;
    font-weight: 500;
  }
  .Value{
    max-width: calc(100% - 120px);
    word-break: break-all;
    word-wrap: break-word;
    overflow: auto;    
    margin-left: 10px;
    .Image{
      display: block;
      margin-right: 10px;
      width: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid #E4E7E6;
    }
    &.NFT{
      .Image{
        border-radius: 6px;
        overflow: hidden;
      }
    }
    .copy{
      margin-left: 10px;
      vertical-align: middle;

    }
  }

  .data {
    max-width: calc(100% - 100px);
    margin-left: 10px;
    .Text{
      margin-bottom: 14px;

      &:last-child{
        margin-bottom: 0px;
      }
    }    
    .Key{
      width: 200px;
      font-weight: normal;
      color: #838383;
      word-break: break-all;
      word-wrap: break-word;
      overflow: auto;         
    }
    .Value{
      width: calc(100% - 140px);
      word-break: break-all;
      word-wrap: break-word;
      overflow: auto;    
      margin-left: 10px;
    .Image{
      display: block;
      margin-right: 10px;
      width: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid #E4E7E6;
    }
    &.NFT{
      .Image{
        border-radius: 6px;
        overflow: hidden;
      }
    }
    .copy{
      margin-left: 10px;
      vertical-align: middle;
    }
  }    
    
  }

  .List{
    background: #fff;
    min-height: 414px;
    padding: 10px;
    .Title{
      border-bottom: 1px solid #FAFAFA;
      padding-bottom: 4px;
      padding-left: 12px;
      .Value{
        margin-left: 10px;
      }
    }
    .ReceiveInfo{
      word-break: break-all;
      word-wrap: break-word;
      overflow: auto;        
      margin: 0 auto;
      padding: 14px 0;
      border-bottom: 1px solid #FAFAFA;
      &:last-child{
        border-bottom: none;
      }
      .Image{
        display: block;
        margin-right: 10px;
        width: 40px;
        height: 40px;
        border-radius: 100px;
        border: 1px solid #E4E7E6;
      }
      .Number{
        text-align: right;
        width: 200px;
        vertical-align: middle;
      }
      .copy{
        margin-left: 10px;
        vertical-align: middle;
      }      
    }
  }
  .Chain{
    width: 100%;
    padding: 14px 12px;
  }
  
}

.context {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    .tip {
      background-color: rgba(40, 40, 40, 0.8);
      color: aliceblue;
      font-size: 14px;
      padding: 10px;
      border-radius: 10px;
    }
  }
</style>
